window.Vue = require('vue');
window._ = require('lodash');
window.axios = require('axios');


// // Plugins
Vue.use(require('vue-moment'));


window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

Vue.mixin({
    methods: {
        route: route
    }
});

var lang = $('html').attr('lang');
if(lang !== 'de'){
    lang = 'en';
}
Vue.config.lang = lang;

if(sdWindow.debug === true) {
    Vue.config.devtools = true;
    Vue.config.debug = true;
} else {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}

window.bus = new Vue({
    //component: () => import(/* webpackChunkName: "about" */ './views/Play.vue'),
    created: function () {

    }
});

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

document.addEventListener("DOMContentLoaded", function() {

    window.setTimeout(function() {
        $('body').addClass("dom-content-loaded");
    }, 0);
});
